import request from '@/utils/request'

let OpinionApi = {

  /*意见反馈列表*/
  list(data) {
    return request._post('/shop/plus.opinions.Index/index', data);
},
/*添加意见反馈*/
add(data) {
    return request._post('/shop/plus.opinions.Index/add', data);
},
/*修改意见反馈*/
edit(data) {
    return request._post('/shop/plus.opinions.Index/edit', data);
},
/*删除意见反馈*/
del(data) {
    return request._post('/shop/plus.opinions.Index/del', data);
},
/*意见反馈详情*/
detail(data) {
  return request._post('/shop/plus.opinions.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.opinions.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.opinions.Setting/getSetting', data, errorback);
    },
}
export default OpinionApi;



// WEBPACK FOOTER //
// ./src/api/opinions.js